import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBriefcase,
  faCamera,
  faCreditCard,
  faEnvelopesBulk,
  faFilePdf,
  faFileSignature,
  faFileUpload,
  faGraduationCap,
  faIdCard,
  faLocationDot,
  faMapMarker,
  faTags,
  faUser,
  faUserGraduate,
  faUserGroup,
  faUserTie,
} from "@fortawesome/free-solid-svg-icons";
import MilestoneChart from "./MilestoneChart";
import callApi from "src/services/Common/api";
import { useSetRecoilState } from "recoil";
import { alertMessageState, loadingState } from "src/atom/LoadingState";

const DashBoard = () => {
  const [data, setData] = useState(null);
  const setAlertMessage = useSetRecoilState(alertMessageState);
  const enableLoader = useSetRecoilState(loadingState);

  const fetchCountApiCall = async () => {
    enableLoader(true);
    const response = await callApi(
      "/v1/api/fetchDashboardCounts",
      "GET",
      null,
      true,
      setAlertMessage
    );
    if (response.success != false) {
      setData(response.body);
    }
    enableLoader(false);
  };

  const colors = [
    "rgb(253, 253, 150)",
    "rgb(255, 228, 181)",
    "rgb(193, 225, 193)",
    "#FFCFCF",
    "#CDC1FF",
    "#D7D3BF",
    "#FFEEA9",
  ];

  const icons = {
    "Personal Details": faUser,
    "Category Details": faTags,
    "Address Details": faMapMarker,
    "Photo & Sign": faCamera,
    Qualifications: faGraduationCap,
    "Post Category": faBriefcase,
    Payment: faCreditCard,
    "Uploaded Documents": faFileUpload,
    "Declaration Upload": faFileSignature,
  };

  useEffect(() => {
    fetchCountApiCall();
  }, []);

  return (
    <>
      <div className="card">
        <div
          className="card-header"
          style={{ backgroundColor: "rgb(60, 75, 100)", color: "white" }}
        >
          Data Overview and Analytics
        </div>
        <div className="card-body">
          
          <div className="card mt-2">
            <div
              className="card-header"
              style={{ backgroundColor: "rgb(60, 75, 100)", color: "white" }}
            >
              Users Analytics
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <div className="row">
                    <div className="col-md-12 mb-2">
                      <div
                        className="card"
                        style={{
                          backgroundColor: "rgb(193, 225, 193)",
                          textAlign: "center",
                          height: "120px",
                        }}
                      >
                        <div className="card-body">
                          <div className="d-flex align-items-center">
                            <FontAwesomeIcon
                              icon={faUserGroup}
                              className="fa-2x mb-2"
                            />
                            <h6 className="ms-2">Old Users</h6>
                          </div>

                          <h4>{data?.oldRegistrations}</h4>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 mb-2">
                      <div
                        className="card"
                        style={{
                          backgroundColor: "#D6E9F8",
                          textAlign: "center",
                          height: "120px",
                        }}
                      >
                        <div className="card-body">
                          <div className="d-flex align-items-center">
                            <FontAwesomeIcon
                              icon={faUserGroup}
                              className="fa-2x mb-3"
                            />
                            <h6 className="ms-2">Old Registered Users</h6>
                          </div>
                          <h4>{data?.oldOnboarded}</h4>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 mb-2">
                      <div
                        className="card"
                        style={{
                          backgroundColor: "#D6E9F8",
                          textAlign: "center",
                          height: "120px",
                        }}
                      >
                        <div className="card-body">
                          <div className="d-flex align-items-center">
                            <FontAwesomeIcon
                              icon={faUserGroup}
                              className="fa-2x mb-3"
                            />
                            <h6 className="ms-2">Users Declaration (Old)</h6>
                          </div>
                          <h4>{data?.oldDeclarations}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="row">
                    <div className="col-md-12 mb-2">
                      <div
                        className="card"
                        style={{
                          backgroundColor: "rgb(193, 225, 193)",
                          textAlign: "center",
                          height: "120px",
                        }}
                      >
                        <div className="card-body">
                          <div className="d-flex align-items-center">
                            <FontAwesomeIcon
                              icon={faUserGroup}
                              className="fa-2x mb-2"
                            />
                            <h6 className="ms-2">New Users</h6>
                          </div>
                          <h4>{data?.newRegistrations}</h4>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 mb-2">
                      <div
                        className="card"
                        style={{
                          backgroundColor: "#D6E9F8",
                          textAlign: "center",
                          height: "120px",
                        }}
                      >
                        <div className="card-body">
                          <div className="d-flex align-items-center">
                            <FontAwesomeIcon
                              icon={faUserGroup}
                              className="fa-2x mb-2"
                            />
                            <h6 className="ms-2">Newly Registered Users</h6>
                          </div>
                          <h4>{data?.newRegistrations}</h4>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 mb-2">
                      <div
                        className="card"
                        style={{
                          backgroundColor: "#D6E9F8",
                          textAlign: "center",
                          height: "120px",
                        }}
                      >
                        <div className="card-body">
                          <div className="d-flex align-items-center">
                            <FontAwesomeIcon
                              icon={faUserGroup}
                              className="fa-2x mb-3"
                            />
                            <h6 className="ms-2">Users Declaration (New)</h6>
                          </div>
                          <h4>{data?.newDeclarations}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row ms-3 mt-2">
            The count below represents the total number of candidates who have
            filled that section.
          </div>
          <div className="card mt-2">
            <div
              className="card-header"
              style={{ backgroundColor: "rgb(60, 75, 100)", color: "white" }}
            >
              Milestones Analytics
            </div>
            <div className="card-body">
              <div className="row">
                {data &&
                  data.milestoneStatus.map((milestone, index) => (
                    <div className="col-md-3 mb-2" key={index}>
                      <div
                        className="card"
                        style={{
                          backgroundColor: colors[index % colors.length],
                          textAlign: "center",
                          height: "120px",
                        }}
                      >
                        <div className="card-body">
                          <div className="d-flex align-items-center">
                            <FontAwesomeIcon
                              icon={icons[milestone.milestoneName]}
                              className="fa-2x mb-3"
                            />
                            <h6 className="ms-2">{milestone.milestoneName}</h6>
                          </div>
                          <h4>{milestone.count}</h4>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>

          {/* <div className="row mt-4">
            <div className="col-md-3"></div>
            <div className="col-md-6">
              <div className="card">
                <MilestoneChart />
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default DashBoard;
